module.exports = __webpack_public_path__ + "img/lanterns.bca03eab.gif";